// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type ConversationsKickResponse = SlackAPIResponse & {
  error?: string;
  errors?: Errors;
  needed?: string;
  ok: boolean;
  provided?: string;
};

export interface Errors {}
